import { DATE_FORMATS, DAY_OF_WEEK } from "@dw/constants";
import { IDanceClass } from "@dw/models/danceClass";
import { TDateFormat } from "@dw/models/shared";
import { dayjs, Dayjs, isDayjs } from '@dw/dayjs';

export const isDate = (text: string): boolean =>
  !!text &&
  typeof text === "string" &&
  (/^[0-9]{4}-[0-9]{2}-[0-9]{2}$/.test(text) ||
    /^[0-9]{4}-[0-9]{2}-[0-9]{2}T[0-9]{2}:[0-9]{2}:[0-9]{2}(.[0-9]{1,}){0,1}([Z]|(\+[0-9]{2}:[0-9]{2})){0,1}$/.test(
      text
    )) &&
  dayjs(text).isValid();

export const isDateOnly = (text: string): boolean =>
  !!text &&
  typeof text === "string" &&
  /^[0-9]{4}-[0-9]{2}-[0-9]{2}$/.test(text) &&
  dayjs(text, DATE_FORMATS.YearMonthDayIso).isValid();

export const isTimeOnly = (text: string): boolean =>
  !!text &&
  typeof text === "string" &&
  /^[0-9]{2}:[0-9]{2}:[0-9]{2}$/.test(text) &&
  dayjs(text, DATE_FORMATS.HourMinuteSecond24Hour).isValid();

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const formatDate = (value: any, outputFormat: TDateFormat): string => {
  if (!value) {
    return "-";
  }

  const format =
    outputFormat === "datetime"
      ? DATE_FORMATS.FullDateTime
      : outputFormat === "time"
        ? DATE_FORMATS.HourMinute
        : DATE_FORMATS.DayMonthYear;

  if (isDayjs(value)) {
    return value.format(format);
  }

  return dayjs(value).format(format);
};

export const getDanceClassDates = (danceClass: IDanceClass): { start: Dayjs; end: Dayjs; } => {
  const startOfWeek = dayjs().startOf('week');
  let daysToAdd = 0;
  switch (danceClass.dayOfWeek) {
    case DAY_OF_WEEK.MONDAY: daysToAdd = 1; break;
    case DAY_OF_WEEK.TUESDAY: daysToAdd = 2; break;
    case DAY_OF_WEEK.WEDNESDAY: daysToAdd = 3; break;
    case DAY_OF_WEEK.THURSDAY: daysToAdd = 4; break;
    case DAY_OF_WEEK.FRIDAY: daysToAdd = 5; break;
    case DAY_OF_WEEK.SATURDAY: daysToAdd = 6; break;
  }

  const classDayOfWeek = startOfWeek.add(daysToAdd, 'days');
  const classStartTime = dayjs(danceClass.startTime, 'h:mma');
  const classEndTime = dayjs(danceClass.endTime, 'h:mma');

  const start = classDayOfWeek.set('hour', classStartTime.hour()).set('minute', classStartTime.minute());
  const end = classDayOfWeek.set('hour', classEndTime.hour()).set('minute', classEndTime.minute());

  return {
    start,
    end
  }
}
